import axiosInstance from "services/AxiosInstance";

export const deleteAccount = async (id: string) => {
  const response = await axiosInstance.delete(`/accounts/${id}`);
  return response.data;
};
